import React, { ReactElement } from 'react';

interface IProps {
  name: string;
  srcUrl?: string;
}

// Displays a circular image for things like blog posts and collections
export default function Avatar({ name, srcUrl }: IProps): ReactElement {
  return (
    <img
      className="mr-3 w-9 rounded-full"
      alt={name}
      loading="lazy"
      src={srcUrl}
    />
  );
}
